import Typography from '@components/_atoms/Typography';
import { TypoVariant } from '@constants/atoms';
import styled from '@emotion/styled';
import { gray, primary } from '@styles/Colors';
import React from 'react';

const SummaryTextWrapper = styled.div`
  display: flex;
  gap: 8px;
`;

const SummaryText = styled.span<{
  active?: boolean;
  fontSize: number;
  activeColor: string;
  defaultColor: string;
  isClickEvent: boolean;
}>`
  color: ${(props) => (props.active ? props.activeColor : props.defaultColor)};

  font-size: ${(props) => `${props.fontSize}px`};
  font-style: normal;
  font-weight: ${(props) => (props.active ? 700 : 400)};
  line-height: 20px;
  letter-spacing: -0.28px;

  ${(props) => props.isClickEvent && `cursor: pointer;`}
`;

const SummaryOrText = styled.span<{ fontSize: number }>`
  color: ${gray.gray4};

  font-size: ${(props) => `${props.fontSize}px`};
  font-weight: 700;
  line-height: 20px;
  letter-spacing: -0.28px;
`;

type Props = {
  readonly fontSize?: number;
  readonly summaryList: string[];
  readonly activeColor?: string;
  readonly defaultColor?: string;
  readonly activeIndex?: number;
  readonly onClick?: (index: number) => void;
};

export default function SummaryTextList({
  fontSize = 14,
  summaryList,
  activeIndex,
  activeColor = primary.blue,
  defaultColor = primary.gray,
  onClick,
}: Props) {
  return (
    <SummaryTextWrapper>
      {summaryList.map((item, index) => (
        <React.Fragment key={index}>
          <SummaryText
            active={activeIndex === index}
            fontSize={fontSize}
            activeColor={activeColor}
            defaultColor={defaultColor}
            isClickEvent={!!onClick}
            onClick={() => onClick?.(index)}>
            {item}
          </SummaryText>
          {summaryList.length - 1 > index && <SummaryOrText fontSize={fontSize}>|</SummaryOrText>}
        </React.Fragment>
      ))}
    </SummaryTextWrapper>
  );
}
